import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
function Skeleton({ className, ...props }) {
    return (_jsx("div", { className: cn('bg-accent animate-pulse rounded-md', className), "data-slot": "skeleton", ...props }));
}
export { Skeleton };
